module.exports = __webpack_public_path__ + "static/media/quiz4.6502d935.png";